import Gateway from '@/utils/Gateway';
import BindConfirmDialog from '../components/bind-confirm-dialog';
import BindTipDialog from '../components/bind-tip-dialog';

const bindTelMixin = {
    components: {
        BindConfirmDialog,
        BindTipDialog
    },
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isCountdown() {
            return this.countdown < 61;
        }
    },
    data() {
        return {
            form: {
                tel: '13323232323',
                captcha: '3232'
            },
            hasBindTelCount: 0,
            isBindQQ: false,
            bindTelConfirmDialogVisiable: false,
            bindTelTipDialogVisiable: false,
            captchaErrorInfo: '',
            telErrorInfo: '',
            countdown: 61,
            bindTelLoading: false,
            formRules: {
                tel: [
                    { required: true, trigger: 'blur', message: this.$t('手机号不能为空') },
                    { validate: /^1\d{10}$/, trigger: 'blur', message: this.$t('手机格式错误') }
                ]
            }
        };
    },
    methods: {
        handleConfirmBindTel() {
            this.bindTelHandler();
        },
        bindTelHandler() {
            if (this.isBindQQ) {
                this.bindTelLoading = true;
                const data = {
                    sms_code: this.form.captcha,
                    mobile: this.form.tel
                };
                Gateway.post('/v1/basic.account.account_web.AccountWeb/bindAdminMobile', data)
                    .then(() => {
                        this.bindTelLoading = false;
                        this.$message.success(this.$t('管理员手机添加成功'));
                        this.onInput(false);
                        this.$emit('on-bind-success');
                    })
                    .catch(err => {
                        this.bindTelLoading = false;
                        this.$message.error(err || this.$t('网络错误'));
                        throw err;
                    });
            } else {
                this.bindTelLoading = true;
                const data = {
                    sms_code: this.form.captcha,
                    mobile: this.form.tel,
                    token: this.token
                };
                Gateway.post('/v1/basic.account.account_web.AccountWeb/modifyAdminMobile', data)
                    .then(() => {
                        this.bindTelLoading = false;
                        this.$message.success(this.$t('管理员手机添加成功'));
                        this.onInput(false);
                        this.$emit('on-bind-success');
                    })
                    .catch(err => {
                        this.bindTelLoading = false;
                        this.$message.error(err || this.$t('网络错误'));
                        throw err;
                    });
            }
        },
        hasError(errArr) {
            return errArr.filter(item => !!item).length > 0;
        },
        onCaptchaError(err) {
            // 解决错误信息出现后，消失后不能出现的bug
            this.captchaErrorInfo = err;
        },
        validateForm() {
            return new Promise((resolve, reject) => {
                this.$refs.form.validate().then(res => {
                    if (!this.hasError(res)) {
                        resolve(this.$t('验证成功'));
                    } else {
                        reject(new Error(this.$t('验证失败')));
                    }
                });
            });
        },
        queryRelationCorp() {
            const data = {
                sms_code: this.form.captcha,
                mobile: this.form.tel
            };
            return Gateway.post('/v1/basic.account.account_web.AccountWeb/relationCorpByAdminMobile', data);
        },
        getCaptchaHandler() {
            const data = {
                type: 1,
                mobile: this.form.tel
            };
            return Gateway.post('/v1/basic.account.account_web.AccountWeb/sendLoginMobile', data);
        },
        async handleGetCaptcha() {
            /* eslint-disable no-useless-catch */
            try {
                await this.validateForm();
                await this.getCaptchaHandler();
                this.countdownHandler();
            } catch (err) {
                // this.$message.error(err || '网络错误');
                throw err;
            }
        },
        countdownHandler() {
            this.countdown -= 1;
            this.countdownTimer = setInterval(() => {
                this.countdown -= 1;
                if (this.countdown <= 0) {
                    this.clearTimer();
                    this.resetCountdown();
                }
            }, 1000);

            // clear timer beforeDestroy
            this.$once('hook:beforeDestroy', this.clearTimer);
        },
        resetCountdown() {
            this.countdown = 61;
        },
        clearTimer() {
            /* eslint-disable no-unused-expressions */
            this.countdownTimer && clearInterval(this.countdownTimer);
        },
        handleBindTel(isBindQQ) {
            this.isBindQQ = isBindQQ;
            this.$refs.form.submit();
        },
        async handleSubmit() {
            // 检测验证码的格式，验证码格式正确才提交表单
            const captcha = this.form.captcha.trim();
            if (captcha === '') {
                this.captchaErrorInfo = this.$t('验证码不能为空');
            } else if (!/^\d{4}(?:\d{2})?$/.test(captcha)) {
                // 验证码是长度为 4 位或者 6 位的数字
                this.captchaErrorInfo = this.$t('验证码格式错误');
            } else {
                try {
                    /* eslint-disable camelcase */
                    this.bindTelLoading = true;
                    const { same_certification_count, diff_certification_count } = await this.queryRelationCorp();
                    if (diff_certification_count > 0) {
                        this.bindTelTipDialogVisiable = true;
                        return;
                    }
                    if (same_certification_count >= 100) {
                        this.$message.error(this.$t('该手机号关联的企业数将超过上限(100个)，请更换手机号'));
                        return;
                    }
                    if (same_certification_count > 0) {
                        this.hasBindTelCount = same_certification_count;
                        this.bindTelConfirmDialogVisiable = true;
                        return;
                    }
                    if (same_certification_count === 0) {
                        this.bindTelHandler();
                        return;
                    }
                } catch (err) {
                    this.$message.error(err || this.$t('网络错误'));
                    throw err;
                } finally {
                    this.bindTelLoading = false;
                }
            }
        },
        onInput(show) {
            this.$emit('input', show);
        }
    }
};

export default bindTelMixin;
